// ONE definition of where a signed-in trader / supplier can go, and what each
// place is called (owner, 2026-10-20: «حوسة… ما أعرف وين أروح»). Every header,
// tab row and bottom bar reads its labels and destinations from here, so the
// same place never carries two names and two places never share one —
// before this, «طلباتي» meant RFQ requests in the dashboard and marketplace
// orders in the market header, and Messages was «المحادثات» on one screen and
// «الرسائل» on the next.
//
// Apple HIG basics applied: at most five top-level destinations per role, the
// same set on desktop and phone, secondary places under «المزيد».

const L = (ar, en, zh) => ({ ar, en, zh });

export const NAV_LABELS = {
  store:       L('المتجر', 'Store', '商城'),
  dashboard:   L('لوحتي', 'Dashboard', '控制台'),
  quotes:      L('طلبات التسعير', 'Quote requests', '询价需求'),
  purchases:   L('مشترياتي', 'My purchases', '我的购买'),
  messages:    L('الرسائل', 'Messages', '消息'),
  more:        L('المزيد', 'More', '更多'),
  // supplier
  supHome:     L('الرئيسية', 'Home', '主页'),
  supRequests: L('الطلبات', 'Requests', '需求'),
  supProducts: L('منتجاتي', 'My products', '我的产品'),
  supOffers:   L('عروضي', 'My offers', '我的报价'),
};

export const navLabel = (key, lang) => {
  const entry = NAV_LABELS[key];
  return entry ? (entry[lang] || entry.ar) : key;
};

// Trader. `purchasesPath` depends on whether the marketplace is live: its
// orders are the trader's purchases; without it the direct-purchase tab is.
export function buyerNav({ hioBuyOnly } = {}) {
  return [
    { key: 'store',     path: hioBuyOnly ? '/market' : '/products' },
    { key: 'dashboard', path: '/dashboard' },
    { key: 'quotes',    path: '/dashboard?tab=requests' },
    { key: 'purchases', path: hioBuyOnly ? '/market/orders' : '/dashboard?tab=direct-orders' },
    { key: 'messages',  path: '/inbox' },
  ];
}

// Supplier: the four places on the phone tab bar (plus «المزيد»), in the same
// order on the desktop tab row and in the site navbar.
export const SUPPLIER_PRIMARY_TABS = ['overview', 'requests', 'my-products', 'messages'];
// «المزيد» — the same order in the desktop menu and the phone sheet.
export const SUPPLIER_MORE_TABS = ['offers', 'direct-orders', 'wallet', 'payout', 'product-inquiries', 'reviews', 'samples', 'settings'];
export function supplierNav() {
  return [
    { key: 'supHome',     tab: 'overview',    path: '/dashboard' },
    { key: 'supRequests', tab: 'requests',    path: '/dashboard?tab=requests' },
    { key: 'supProducts', tab: 'my-products', path: '/dashboard?tab=my-products' },
    { key: 'messages',    tab: 'messages',    path: '/inbox' },
  ];
}
